module.exports = __webpack_public_path__ + "static/media/iphone2.faa74fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/iphone2.png
// module id = 1291
// module chunks = 0